document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('create_customer');
  const password = document.getElementById('RegisterForm-Password');
  const confirmPassword = document.getElementById('RegisterForm-ConfirmPassword');
  const errorMsgWrapper = document.getElementById('RegisterForm-confirm-password-error');

  function validatePassword(e) {
    if (password.value && password.value !== confirmPassword.value) {
      errorMsgWrapper.style.removeProperty('display');
      return false;
    } else {
      errorMsgWrapper.style.display = 'none';
      return true;
    }
  }

  password.addEventListener('input', () => {
    if (confirmPassword.value) validatePassword();
  });
  confirmPassword.addEventListener('input', () => {
    if (password.value) validatePassword();
  });
  form.addEventListener('submit', (e) => {
    if (!validatePassword(e)) {
      e.preventDefault();
    }
  });
});
